import { render, staticRenderFns } from "./AddToBasket.vue?vue&type=template&id=660b1841&"
import script from "./AddToBasket.vue?vue&type=script&lang=js&"
export * from "./AddToBasket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports